/**
 * Joins truthy class names
 */
export const cls = (...classNames: (string | false | null | undefined)[]): string =>
  classNames.filter(Boolean).join(' ')

/**
 * Adds or removes an asterisk from the end of a string based on the `required` boolean.
 * Useful for dealing with translation values that may or may not already end with an asterisk.
 * This function handles multiple asterisks and whitespace at the end of the string.
 * @param str The string to add or remove an asterisk from.
 * @param required Whether the field is required.
 * @returns The string with an asterisk added or removed.
 */
export const withAsteriskIfRequired = (str: string, required: boolean): string => {
  // Remove any trailing combination of asterisks and whitespace
  const withoutAsterisks = str.replace(/(\s*\*)+\s*$/, '')

  // Add a single asterisk if required
  const suffix = required ? '*' : ''

  return `${withoutAsterisks}${suffix}`
}

/**
 * Adds an asterisk to the end of a string, if necessary.
 * @param str The string to add an asterisk to.
 * @returns The string with an asterisk added.
 */
export const withAsterisk = (str: string): string => withAsteriskIfRequired(str, true)

/**
 * Removes leading and trailing slashes from a string.
 * @param str The string to remove slashes from.
 * @returns The string with slashes removed.
 */
export const slashless = (str: string): string => str.replace(/^\/+|\/+$/g, '')
